import { TableRow } from "@mui/material";
import dayjs from "dayjs";
import { FilterType } from "../../../configs/filterTypes";
import { SortType } from "../../../configs/sortTypes";
import { MaterialQuantityTracking } from "../../../data/entities";
import { StyledTableCell } from "../../../shared/components/CustomTable/Styled";
import TableView from "../../../shared/components/TableView";
import { StyledNavLinkNewTab } from "../../../shared/styled/TableStyles";
import { formatNumber } from "../../../utils/format";

const TABLE_COLUMNS = [
    { text: "Mã vật tư", icon: <></> },
    { text: "Tên vật tư", icon: <></> },
    { text: "Kho", icon: <></> },
    { text: "Số lượng tồn kho", icon: <></> },
    { text: "Số lượng nhập", icon: <></> },
    { text: "Số lượng xuất", icon: <></> },
    { text: "Số lượng còn lại", icon: <></> },
];

const MaterialQuantityTrackingSortTypes: SortType[] = [
    {
        field: "name",
        text: "Tên từ A-Z",
        isReversed: true,
    },
    {
        field: "name",
        text: "Tên từ Z-A",
    },
    {
        field: "start_quantity",
        text: "Tồn đầu tăng dần",
        isReversed: true,
    },
    {
        field: "start_quantity",
        text: "Tồn đầu giảm dần",
    },
    {
        field: "total_imported",
        text: "Nhập tăng dần",
        isReversed: true,
    },
    {
        field: "total_imported",
        text: "Nhập giảm dần",
    },
    {
        field: "total_exported",
        text: "Xuất tăng dần",
        isReversed: true,
    },
    {
        field: "total_exported",
        text: "Xuất giảm dần",
    },
    {
        field: "end_quantity",
        text: "Tồn cuối tăng dần",
        isReversed: true,
    },
    {
        field: "end_quantity",
        text: "Tồn cuối giảm dần",
    },
];


const MaterialQuantityTrackingFilterType: FilterType[] = [
    {
        field: "start_date",
        options: [],
        text: "Từ ngày",
        title: "Ngày bắt đầu",
        type: "date",
    },
    {
        field: "end_date",
        options: [],
        text: "Đến ngày",
        title: "Ngày kết thúc",
        type: "date",
    },
    {
        field: "storage",
        options: [
            { text: "Kho 1", value: "Kho 1" },
            { text: "Kho 2", value: "Kho 2" },
        ],
        text: "Tất cả kho",
        title: "Kho",
    },
    {
        field: "is_below_threshold",
        options: [
            {
                text: "Dưới mức",
                value: "true",
            },
            {
                text: "Trên mức",
                value: "false",
            },
        ],
        text: "Tất cả trạng thái",
        title: "Cảnh báo tồn kho",
    },
    {
        field: "expired_date",
        options: [],
        text: "Từ ngày - Đến ngày",
        title: "Ngày đến hạn",
        type: "date_range_utc",
    },
];

export const MaterialQuantityTrackingRow = ({ item }: { item: MaterialQuantityTracking }) => (
    <TableRow>
        <StyledTableCell align="left">
            <StyledNavLinkNewTab
                href={`/materials/${item.id}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {item.material_code?.trim() ? item.material_code : item.id}
            </StyledNavLinkNewTab>
        </StyledTableCell>
        <StyledTableCell align="left">{item.name}</StyledTableCell>
        <StyledTableCell align="left">{item.storage}</StyledTableCell>
        <StyledTableCell align="left">{item.start_quantity !== undefined && item.start_quantity !== null ? formatNumber(item.start_quantity) : "-"}</StyledTableCell>
        <StyledTableCell align="left">{item.total_imported !== undefined && item.total_imported !== null ? formatNumber(item.total_imported) : "-"}</StyledTableCell>
        <StyledTableCell align="left">{item.total_exported !== undefined && item.total_exported !== null ? formatNumber(item.total_exported) : "-"}</StyledTableCell>
        <StyledTableCell align="left">{item.end_quantity !== undefined && item.end_quantity !== null ? formatNumber(item.end_quantity) : "-"}</StyledTableCell>
    </TableRow>
);

const MaterialQuantityTrackingTab = () => (
    <TableView
        url="/materials/quantity-summary-raw/"
        filterTypes={MaterialQuantityTrackingFilterType}
        sortTypes={MaterialQuantityTrackingSortTypes}
        rowElement={MaterialQuantityTrackingRow}
        tableColumns={TABLE_COLUMNS}
        defaultFilterParams={{
            start_date: dayjs().startOf("month").format("YYYY-MM-DD"), // Get first day of the month
            end_date: dayjs().format("YYYY-MM-DD"),
        }}
        textString="Tìm kiếm theo Mã vật tư, tên vật tư"
    />
);

export default MaterialQuantityTrackingTab;
